import { alert } from './component/alert.listener.analytics';
import { routeListenerAnalytics } from './component/route.listener.analytics';
import { addToCartAnalytics } from './component/add-to-cart.listener.analytics';
import { dataSources } from './component/data-sources.listener.analytics';
import { aisleBay } from './component/aisle-bay.listener.analytics';
import { augmentedReality } from './component/augmented-reality.listener.analytics';
import { buybox } from './component/buybox.listener.analytics';
import { calculator } from './component/calculator.listener.analytics';
import { fbt } from './component/fbt.listener.analytics';
import { cardMessaging } from './component/card-messaging.listener.analytics';
import { catalogPromo } from './component/catalog-promo.listener.analytics';
import { categoryList } from './component/category-list.listener.analytics';
import { collectionList } from './component/collection-list.listener.analytics';
import { deliveryOptions } from './component/delivery-options.listener.analytics';
import { fbr } from './component/fbr.listener.analytics';
import { filtersAndRefinements } from './component/filter-refinements.listener.analytics';
import { fulfillment } from './component/fulfillment.listener.analytics';
import { sortRefinements } from './component/sort-refinement.analytics';
import { irg } from './component/irg.listener.analytics';
import { layoutManager } from './component/layout-manager.analytics';
import { mediaGallery } from './component/media-gallery.listener.analytics';
import { trackOOS } from './component/track-out-of-stock.listener.analytics';
import { orderSample } from './component/order-sample.listener.analytics';
import { pagination } from './component/pagination.listener.analytics';
import { price } from './component/price.listener.analytics';
import { productDetails } from './component/product-details.listener.analytics';
import { productOverview } from './component/product-overview.listener.analytics';
import { productResults } from './component/product-results.listener.analytics';
import { superSku } from './component/super-sku.listener.analytics';
import { promotion } from './component/promotion.listener.analytics';
import { sharebelt } from './component/sharebelt.listener.analytics';
import { tabs } from './component/tabs.listener.analytics';
import { visualCategoryNav } from './component/visual-category-nav.listener.analytics';
import { stickyNav } from './component/sticky-nav.listener.analytics';
import { stashEvent } from './component/stash-event.listener';
import { page } from './experience/page';
import { ddoReady } from './component/digital-data.listener.analytics';
import { ratingsReviews } from './component/ratings-reviews';
import { instantCheckout } from './component/instant-checkout.listener.analytics';
import { productPod } from './component/product-pod.listener.analytics';
import { quiz } from './component/quiz.listener.analytics';
import { sizeGuide } from './component/size-guide.listener.analytics';
import { relatedSearch } from './component/related-search.listener.analytics';
import { promotionProducts } from './component/promotion-products.listener.analytics';
import { productHotspots } from './component/product-hotspots.listener.analytics';
import { checkAvailability } from './component/check-availability.listener.analytics';
import { leadGeneration } from './component/lead-generation.listener.analytics';
import { rentalIntent } from './component/rental-intent.listener.analytics';
import { dualPath } from './component/product-add-ons.listener.analytics';
import { seoExperience } from './experience/pages/seo-experience/seo-experience';
import { optOut } from './experience/pages/optOut/optOut';
import { buyItAgain } from './component/buy-it-again.listener.analytics';

const ThdAnalytics = {
  init: () => {
    if (typeof window === 'undefined') return;

    if (!window.THD_EVENT_BUS) {
      window.THD_EVENT_BUS = window.LIFE_CYCLE_EVENT_BUS;
    }

    try {
      seoExperience();
      page();
      routeListenerAnalytics();
      dataSources();
      ddoReady();
      addToCartAnalytics();
      aisleBay();
      alert();
      buybox();
      augmentedReality();
      calculator();
      cardMessaging();
      catalogPromo();
      categoryList();
      collectionList();
      deliveryOptions();
      fbr();
      fbt();
      fulfillment();
      irg();
      layoutManager();
      sortRefinements();
      filtersAndRefinements();
      mediaGallery();
      orderSample();
      pagination();
      price();
      productDetails();
      productHotspots();
      productOverview();
      productResults();
      promotion();
      rentalIntent();
      stickyNav();
      superSku();
      trackOOS();
      sharebelt();
      tabs();
      visualCategoryNav();
      stashEvent();
      ratingsReviews();
      relatedSearch();
      instantCheckout();
      productPod();
      quiz();
      sizeGuide();
      promotionProducts();
      checkAvailability();
      leadGeneration();
      dualPath();
      optOut();
      buyItAgain();
    } catch (err) {
      console.log(err);
    }

  }
};
export { ThdAnalytics };
